'use client';

import { useEffect } from 'react';

/**
 * ServiceWorkerRegistration — Phase 24 PWA
 * Registers /sw.js after the page loads.
 * Runs only in the browser, never on the server.
 */
export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;

    // Register after page is fully loaded to avoid blocking initial render
    const register = () => {
      navigator.serviceWorker?.register('/sw.js', { scope: '/' })?.catch(() => {
          // SW registration failure is non-fatal — app works without it
        });
    };

    if (document.readyState === 'complete') {
      register();
    } else {
      window.addEventListener('load', register, { once: true });
    }
  }, []);

  return null;
}
